// extracted by css-extract-rspack-plugin
export default {"container":"OKhAtjecGmEchNGW","textWrap":"ClwExMty4ysZnh_j"};